import React from 'react'
import { Route, Routes } from 'react-router-dom';

import AllQuotation from '../quotation/AllQuotation';
import ViewMobile from '../quotation/ViewMobile';
import ViewCaterer from '../quotation/ViewCaterer';

const QuotationRuotes = () => {
    return (
        <>
            <Routes>
                <Route path="/all" element={<AllQuotation />} />
                <Route path="/view-mobile" element={<ViewMobile />} />
                <Route path="/view-caterer" element={<ViewCaterer />} />
            </Routes>
        </>
    )
}

export default QuotationRuotes;